import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

import { reducerGetRoutes, reducerGetRoutesFilters, reducerRoutesStatus, reducerRoutesStatusMessage } from "../../reducer/projects/reducers/reducerRoutesList"
import { reducerGetVacantRoutes, reducerGetVacantRoutesFilters } from '../../reducer/projects/reducers/reducerVacantRoutesList'

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetRoutes = (limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    const filter = store.projects.routes.routesInputValues;
    const projectCreateVacancy = store.recruiting.createVacancy.vacancyCreateInputValues.projects;
    const project = projectCreateVacancy ? { project: projectCreateVacancy } : store.projects.projects.currentProject;
    try {
        const response = await axios.post(`${BASE_URL}/json/projects/routes/list`, { limit, page, ...filter, ...project })
        dispatch(reducerGetRoutes({ data: response.data }));
    } catch {
        console.log('err');
    };
}

export const actionGetVacantRoutes = (limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
    dispatch(reducerGetVacantRoutes({ data: [] }));
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    const filter = {
        ...store.projects.vacantRoutes.vacantRoutesInputValues,
        projects: store.projects.vacantRoutes.vacantRoutesInputValues.project,
    };
    try {
        const response = await axios.post(`${BASE_URL}/json/projects/routes/list`, { limit, page, ...filter })
        dispatch(reducerGetVacantRoutes({ data: response.data }));
    } catch {
        console.log('err');
    };
}

export const actionGetRoutesFilters = (data: { id: number | string, name: string }[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
        const response = await axios.post(`${BASE_URL}/json/projects/routes/list/filters`, data)
        dispatch(reducerGetRoutesFilters({ data: response.data }));
        dispatch(reducerGetVacantRoutesFilters({ data: response.data }));
    } catch {
        console.log('err');
    };
}

export const actionUploadStartShift = (id: string, files?: File[]) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const formData = new FormData();

    files && files.forEach((file: File) => {
        formData.append("file", file, file.name);
    });

    try {
        const response = await axios.post(`${BASE_URL}/json/projects/routes/uploadRouteTimes/${id}`, formData);
        console.log(response);
        dispatch(reducerRoutesStatus(202));
    } catch (err: any) {
        let cleanedMessage = err.response.data.replace('400 BAD_REQUEST', '').replace(/"/g, '');

        cleanedMessage = cleanedMessage.replace(/([^.])(данных)/g, '$1$2.');

        dispatch(reducerRoutesStatus(4));
        dispatch(reducerRoutesStatusMessage(cleanedMessage));
    };
}